import React from 'react';
import { useAppTheme } from '../../hooks/useAppTheme';
import { AuthHeader } from '../auth/AuthHeader';
import '../../styles/auth.css';

export interface AuthLayoutProps {
  children: React.ReactNode;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  /** @deprecated Side panel removed — kept for call-site compatibility */
  hidePanel?: boolean;
  /** Wider form card for multi-step request forms */
  wide?: boolean;
  /** Tighter spacing — fits multi-step request forms without scrolling */
  compact?: boolean;
}

/**
 * Centered EMS auth card with fixed top-left platform header.
 * Uses dedicated auth.css (not Tailwind) so Bootstrap cannot break the layout.
 */
export const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  title,
  subtitle,
  wide = false,
  compact = false,
}) => {
  useAppTheme();

  const cardClassName = [
    'auth-card',
    wide ? 'auth-card--wide' : '',
    compact ? 'auth-card--compact' : '',
  ]
    .filter(Boolean)
    .join(' ');

  const bodyClassName = ['auth-main__body', compact ? 'auth-main__body--compact' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <div className={`auth-shell${compact ? ' auth-shell--compact' : ''}`}>
      <AuthHeader />

      <main className="auth-main">
        <div className={bodyClassName}>
          <div className={cardClassName}>
            {title ? <h1 className="auth-title app-heading-accent">{title}</h1> : null}
            {subtitle ? <p className="auth-subtitle">{subtitle}</p> : null}
            {children}
          </div>
        </div>

        <p className="auth-copyright">
          &copy; {new Date().getFullYear()} Traxccel. All rights reserved.
        </p>
      </main>
    </div>
  );
};

export default AuthLayout;
